module.exports = __webpack_public_path__ + "static/media/12.134e1663.svg";